import { IconHomeSearch, IconPhoneCall } from '@tabler/icons-react'
import ButtonPrime from '@/components/navigation/ButtonPrime'
import React from 'react'
import BeratungsterminModal from '@/components/form/BeratungsterminModal'

export default function VorteileSectionBeratung() {
  return (
    <div>
        <div className='max-w-[85rem] px-4 md:py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto'>
        <div className='py-10'>
            {/* <h2 className='font-semibold text-dark-100 font-serif text-2xl'>Ihre Vorteile</h2> */}
        <div className='md:flex flex-wrap justify-between py-5 block'>
            <div className='py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]'>
                <img className='size-12' src="/Icons/beratung-vorteile-1.svg" alt="" />
                <h3 className='pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif'>Unverbindlich starten</h3>
                <p className='text-dark-200 '>Lassen Sie sich kostenlos und ohne Verpflichtung beraten – persönlich, ehrlich und auf Augenhöhe.
                </p>
            </div>
            <div className='py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]'>
                <img className='size-12 ' src="/Icons/beratung-vorteile-2.svg" alt="" />
                <h3 className='pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif'>Klarheit schaffen</h3>
                <p className='text-dark-200 '>Wir hören zu und nehmen uns Zeit für Ihre Fragen – persönlich und mit Erfahrung seit 1978.</p>
            </div>
            
            <div className='py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]'>
                <img className='size-12' src="/Icons/beratung-vorteile-3.svg" alt="" />
                <h3 className='pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif'>Marktwert erfahren</h3>
                <p className='text-dark-200 '>Wir kennen den lokalen Markt und bewerten Ihre Immobilie kostenlos im Rahmen unserer Beratung.
                </p>
            </div>
            <div className='py-10  md:max-w-[20rem]  h-full text-center flex flex-col items-center justify-center min-w-[10rem]'>
                <img className='size-12' src="/Icons/beratung-vorteile-4.svg" alt="" />
                <h3 className='pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif'>Sicher entscheiden</h3>
                <p className='text-dark-200 '>Eine Beratung schafft Klarheit – als Grundlage für Ihren nächsten Schritt.
                </p>
            </div>

        </div>
        <BeratungsterminModal trigger={        <ButtonPrime text='Erstgespräch buchen' icon={<IconPhoneCall/>} className='w-full mx-auto md:w-fit md:mt-10' />
} />

        </div>

    </div>

    </div>
  )
}
